import React from 'react';
import { motion } from 'framer-motion';
import { Clock, Search, Edit3, Film, Upload } from 'lucide-react';
const steps = [{
  time: 'Min 0-10',
  title: 'Identificar Tendencia',
  desc: 'Buscar en TikTok videos con más de 1M de vistas.',
  icon: Search
}, {
  time: 'Min 10-25',
  title: 'Reescribir Guion',
  desc: 'Usar ChatGPT para crear un ángulo diferente.',
  icon: Edit3
}, {
  time: 'Min 25-40',
  title: 'Producción',
  desc: 'Generar audio con ElevenLabs y montar video en CapCut.',
  icon: Film
}, {
  time: 'Min 40-60',
  title: 'Publicación',
  desc: 'Programar en TikTok, Reels y Shorts.',
  icon: Upload
}];
export function RoutineTimeline() {
  return <div className="max-w-3xl mx-auto relative" data-id="element-174">
      {/* Central Line */}
      <div className="absolute left-4 md:left-1/2 top-0 bottom-0 w-0.5 bg-[#d4a843]/30 transform md:-translate-x-1/2" data-id="element-175" />

      <div className="space-y-12" data-id="element-176">
        {steps.map((step, index) => <motion.div key={index} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: index * 0.15,
        duration: 0.6
      }} className={`flex flex-col md:flex-row items-start md:items-center ${index % 2 === 0 ? 'md:flex-row-reverse' : ''} relative`} data-id="element-177">
            {/* Timeline Dot */}
            <div className="absolute left-4 md:left-1/2 w-4 h-4 bg-[#0a1628] border-2 border-[#d4a843] rounded-full transform -translate-x-1/2 z-10 mt-1.5 md:mt-0" data-id="element-178" />

            {/* Content Card */}
            <div className={`ml-12 md:ml-0 md:w-1/2 ${index % 2 === 0 ? 'md:pl-12' : 'md:pr-12 text-right'}`} data-id="element-179">
              <div className={`bg-[#1a2744] p-6 rounded-xl border border-[#d4a843]/10 hover:border-[#d4a843]/40 transition-colors shadow-lg group ${index % 2 !== 0 ? 'md:items-end md:flex md:flex-col' : ''}`} data-id="element-180">
                <div className="inline-flex items-center space-x-2 bg-[#0a1628] px-3 py-1 rounded-full border border-[#d4a843]/30 mb-3" data-id="element-181">
                  <Clock className="w-3 h-3 text-[#d4a843]" data-id="element-182" />
                  <span className="text-xs font-bold text-[#d4a843]" data-id="element-183">
                    {step.time}
                  </span>
                </div>

                <h3 className="text-xl font-bold text-white mb-2 font-serif flex items-center gap-2" data-id="element-184">
                  {index % 2 === 0 && <step.icon className="w-5 h-5 text-[#d4a843] md:hidden" data-id="element-185" />}
                  {step.title}
                  {index % 2 !== 0 && <step.icon className="w-5 h-5 text-[#d4a843] md:hidden" data-id="element-186" />}
                </h3>

                <p className="text-gray-400 text-sm" data-id="element-187">{step.desc}</p>
              </div>
            </div>

            {/* Empty space for the other side */}
            <div className="hidden md:block md:w-1/2" data-id="element-188" />
          </motion.div>)}
      </div>
    </div>;
}